import { render } from "./acntInfInp.vue?vue&type=template&id=1c265970"
import script from "./acntInfInp.vue?vue&type=script&lang=js"
export * from "./acntInfInp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__